export const getCustomerReviewRenderState = ({ hasRequested, isFetch, hasSnapshot, error }) => ({
  showLoadingTable: !hasSnapshot && (!hasRequested || isFetch),
  showRetryOnly: !hasSnapshot && hasRequested && !isFetch && !error,
  showList: hasSnapshot || !hasRequested || isFetch,
  showPagination: hasSnapshot,
  showError: Boolean(error) && !isFetch
});
